import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { Button } from 'react-bootstrap';

import t from '../../lib/I18n';
import ModalActions from '../../actions/ModalActions';

import NotificationListItem from './ListItem';
import BaseModal from '../general/BaseModal';

export default function NotificationCentreModal ({ show, notifications }) {
    const closeModal = () => ModalActions.close(this);
    const footer = (
        <Button
            bsStyle="default"
            onClick={ closeModal }
            className="close btn-md pull-left">
            { t('button.text.close') }
        </Button>
    );
    return (
        <BaseModal
            show={ show }
            footer={ footer }
            titleText='notifications.accountActions.text'
            className="modal--xs">
            <ul className="notification-list">
                { notifications.map((notification, index) =>
                    <NotificationListItem key={ index }
                        notification={ notification } />
                ) }
            </ul>
        </BaseModal>
    );
}

NotificationCentreModal.propTypes = {
    show: PropTypes.bool,
    notifications: PropTypes.instanceOf(List).isRequired
};

NotificationCentreModal.defaultProps = {
    show: true
};
